import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { signIn, signOut } from "aws-amplify/auth"
import { useGeneralContext } from "../../Contexts/GeneralContext/GeneralProvider"
import LoadingInfo from "../../Components/SharedComponents/OtherComponents/LoadingInfo"
import { TranslateSignInError } from "../../Helpers/TranslateHelpers"
import { LoginModalInterface } from "../../Interfaces/ComponentsInterfaces/LoginPageInterface"
import LinkClassLogo from '../../Assets/LinkClassLogo.png'
import '../../Views/LoginPage/LoginPage.css'


function LoginModal({ setLoginModal, setLoginUsername }: LoginModalInterface) {

	const { handleLogin } = useGeneralContext()

	const navigate = useNavigate()

	const [username, setUsername] = useState<string>('')
	const [password, setPassword] = useState<string>('')
	const [isRevealingPassword, setIsRevealingPassword] = useState<boolean>(false)
	const [isLoading, setIsLoading] = useState<boolean>(false)
	const [userMessage, setUserMessage] = useState<string>('')


	const handleUserchange = (e: React.ChangeEvent<HTMLInputElement>) => {
		e.preventDefault()
		setUsername(e.target.value)
	}

	const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		e.preventDefault()
		setPassword(e.target.value)
	}

	// A session left over from a previous visit makes Cognito reject signIn outright.
	// Clearing it locally is the one sign out we do without the user asking for it.
	const signInClearingStaleSession = async () => {
		try {
			return await signIn({ username: username, password: password })
		} catch (error) {
			if ((error as { name?: string })?.name !== 'UserAlreadyAuthenticatedException') {
				throw error
			}
			await signOut()
			return await signIn({ username: username, password: password })
		}
	}

	const handleLoginForModal = async () => {
		if (username.trim() === '' || password.trim() === '') {
			setUserMessage('Nombre de usuario o contraseña incompleto.')
			return
		}
		setUserMessage('')
		setIsLoading(true)

		let signInResult
		try {
			signInResult = await signInClearingStaleSession()
		} catch (error) {
			console.error('Cognito signIn failed:', error)
			setUserMessage(TranslateSignInError(error, password))
			setIsLoading(false)
			return
		}

		setLoginUsername(username)

		if (!signInResult.isSignedIn) {
			if (signInResult.nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
				setLoginModal('ConfimPassword')
			} else {
				setUserMessage('Tu cuenta requiere un paso adicional que aún no podemos completar aquí. Contacta a tu colegio.')
			}
			setIsLoading(false)
			return
		}

		// Cognito accepted the credentials, so any failure past this point is not a password problem.
		try {
			await handleLogin(username)
		} catch (error) {
			console.error('Session setup failed after a successful signIn:', error)
			setUserMessage('Iniciaste sesión, pero no pudimos cargar tus datos. Revisa tu conexión e intenta nuevamente.')
			setIsLoading(false)
		}
	};

	const handleReturnToLanding = () => {
		navigate('/')
	}


	return (
		<div className="InternalDiv">
			<div className="LoginLogoDiv" onClick={handleReturnToLanding}>
				<img src={LinkClassLogo} alt="LinkClassLogo" />
			</div>
			{isLoading ? (
				<LoadingInfo />
			) : (
				<>
					<h1>Inicio de sesión</h1>
					{userMessage && <p className="LoginMessage">{userMessage}</p>}
					<div className="LoginInputDiv">
						<input
							type='text'
							placeholder="Usuario..."
							value={username}
							onChange={handleUserchange}
							onKeyDown={(e) => {
								if (e.key === 'Enter') {
									e.preventDefault();
								}
							}}
						/>
					</div>
					<div className="LoginPassWordInput">
						<input
							type={isRevealingPassword ? "text" : "password"}
							value={password}
							placeholder="Contraseña"
							onChange={handlePasswordChange}
							onKeyDown={(e) => {
								if (e.key === 'Enter') {
									e.preventDefault();
								}
							}}
						/>
						<button type="button" onClick={() => setIsRevealingPassword(!isRevealingPassword)}>
							{isRevealingPassword ? "Ocultar Contraseña" : "Mostrar contraseña"}
						</button>
					</div>
					<div className="ForgetPassWordDiv">
						<button type="button" onClick={() => setLoginModal('LostPassword')}>
							Olvide mi contraseña
						</button>
					</div>
					<div className="FinalButtonDiv">
						<button type="button" onClick={handleLoginForModal}>
							Iniciar Sesion
						</button>
					</div>
				</>
			)}
		</div>
	)
}

export default LoginModal